import { render, staticRenderFns } from "./addRecord.vue?vue&type=template&id=755588d1&scoped=true&"
import script from "./addRecord.vue?vue&type=script&lang=js&"
export * from "./addRecord.vue?vue&type=script&lang=js&"
import style0 from "./addRecord.vue?vue&type=style&index=0&id=755588d1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "755588d1",
  null
  
)

export default component.exports